import { useTranslations } from 'next-intl'
import styles from './AgeModal.module.css'
import Button, { ButtonKind } from '@/components/UI/Buttons/Button/Button'
import ImageOver18 from '@/assets/img/Image_Over18.svg'
import { useRouter } from 'next/navigation'
import { useModalStore } from '@/stores/useModalStore'

interface AgeModalProps {
	onClose: (value: boolean) => void
}

export default function AgeModal({ onClose }: AgeModalProps) {
	const t = useTranslations('AgeModal')
	const router = useRouter()
	const { closeModal, setShowAge18 } = useModalStore()
	
	/**
	 * If the user cancels, we want to take them back to the previous page.
	 * If therer is no previous page, we take them to the homepage.
	 * In both cases, we close the modal after a short delay to allow the navigation to happen smoothly.
	 */
	function cancel() {
		if (window.history.length > 1) router.back()
		else router.push('/home')
		window.setTimeout(() => {
			onClose(false)
			closeModal()
		}, 500)
	}

	/**
	 * If the user confirms, we just close the modal and allow the videos to play.
	 */
	function confirm () {
		setShowAge18(false)
		onClose(true)
		closeModal()
	}

	return (
		<div className={styles.ageModalWrapper}>
			<div className={styles.contentWrapper}>
				<ImageOver18 className={styles.image} />
				
				<div className={styles.text}>
					<h2 className={`title2`}>{t('title')}</h2>
					<p className={`bodyTextLarge`}>{t('subtitle')}</p>
				</div>
			</div>

			<div className={styles.controls}>
				<Button kind={ButtonKind.SECONDARY} onClick={cancel}>{t('cancel')}</Button>
				<Button onClick={confirm}>{t('accept')}</Button>
			</div>
		</div>
	)
}